/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registration_Closed_MessageInputs */

const en_registration_closed_message = /** @type {(inputs: Registration_Closed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The application phase for Matching Week 2026 starts on 26 October and ends on 1 November. You can only apply for the positions shown here during this period!`)
};

const de_registration_closed_message = /** @type {(inputs: Registration_Closed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bewerbungsphase für die Matching Week 2026 beginnt am 26. Oktober und endet am 1. November. Nur in diesem Zeitraum kannst du dich für die hier angezeigten Stellen bewerben!`)
};

/**
* | output |
* | --- |
* | "The application phase for Matching Week 2026 starts on 26 October and ends on 1 November. You can only apply for the positions shown here during this period!" |
*
* @param {Registration_Closed_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const registration_closed_message = /** @type {((inputs?: Registration_Closed_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registration_Closed_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_registration_closed_message(inputs)
	return en_registration_closed_message(inputs)
});